import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
export var useStyles = makeStyles({
    imageButton: {
        width: '200px',
    },
});
/**
 * SmartCheckの確認画面キャンセルボタン画像コンポーネント
 * @param props
 */
export var SmartCheckConfirmCancelButton = function (props) {
    var classes = useStyles(props);
    if (props.imageUrl) {
        // クーポンマスタで画像が登録されている場合は、その画像を出す
        return (React.createElement("input", { type: "image", src: props.imageUrl, className: classes.imageButton, alt: "SmartCheck\u753B\u50CF", onClick: props.onClick }));
    }
    else {
        // 登録されていない場合は、デフォルトの画像を出す
        return (React.createElement("input", { type: "image", src: "/smartCheck-cancel-button-default.gif", className: classes.imageButton, alt: "SmartCheck\u753B\u50CF", onClick: props.onClick }));
    }
};
//# sourceMappingURL=SmartCheckConfirmCancelButton.js.map